export default "__VITE_ASSET__B9GrSVz5__"